import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clock-label" }

import Tools from '@/utils/Tools';
import { onMounted, ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ClockComponent',
  setup(__props) {

const datetime = ref<string>('');
function GetTime(){
     const time = Date.now();
     datetime.value = Tools.ConvertTimestamp(time,'America/New_York','MM-DD HH:mm:ss');
     setTimeout(() => {
        GetTime();
     }, 1000);
}
onMounted(()=>{
    GetTime();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(datetime.value), 1))
}
}

})